<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 space-y-4">
  <!-- Sticky top: header + (on small) collapsible filter/sort toolbar stay pinned while the list scrolls. -->
  <div class="sticky top-0 z-20 -mx-4 sm:-mx-6 lg:-mx-8 -mt-4 px-4 sm:px-6 lg:px-8 pt-4 pb-3 space-y-3">
  <!-- Header: title + context + "add user" toggle. -->
  <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
    <div class="flex items-center gap-3">
      <span class="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-theme-primary-50 text-theme-primary-600">
        <svg class="h-6 w-6" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
          <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>
        </svg>
      </span>
      <div>
        <h1 class="text-xl font-bold text-gray-900 tracking-tight">Benutzer</h1>
        <p class="text-sm text-gray-500">
          {{ (company_filter || shard_filter) ? (company?.name + (shard ? ' · ' + shard.name : '')) : 'Alle Benutzer der Plattform.' }}
        </p>
      </div>
    </div>
    <div class="flex items-center justify-center gap-2 lg:justify-end">
      <button type="button" (click)="showFilters = !showFilters"
              class="inline-flex lg:hidden items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-all duration-200">
        <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 0 1 .628.74v2.288a2.25 2.25 0 0 1-.659 1.59l-4.682 4.683a2.25 2.25 0 0 0-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 0 1 7.5 18.25v-5.757a2.25 2.25 0 0 0-.659-1.591L2.16 6.22A2.25 2.25 0 0 1 1.5 4.629V2.34a.75.75 0 0 1 .628-.74Z"/>
        </svg>
        Filter
        <svg class="h-4 w-4 transition-transform duration-200" [class.rotate-180]="showFilters"
             viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>
        </svg>
      </button>
      <button (click)="creator = !creator" type="button"
              class="inline-flex items-center justify-center px-4 py-2 text-sm bg-theme-primary-600 text-white rounded-xl
                     hover:bg-theme-primary-700 font-semibold shadow-lg shadow-theme-primary-100 hover:shadow-xl
                     transition-all duration-200 active:scale-95">
        <svg class="h-4 w-4 mr-1.5 transition-transform duration-200" [class.rotate-45]="creator"
             viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M10 5a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 10 5Z"/>
        </svg>
        {{ creator ? 'Schließen' : 'Benutzer hinzufügen' }}
      </button>
    </div>
  </div>

  <!-- Toolbar: search + status filter + sort. Collapsible on small (toggled by Filter), always shown on lg. -->
  <div [ngClass]="showFilters ? 'flex' : 'hidden'"
       class="flex-col gap-3 lg:flex-row lg:items-center lg:!flex">
    <div class="relative flex-1">
      <svg class="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400"
           viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd"
              d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
              clip-rule="evenodd"/>
      </svg>
      <input #searchInput (input)="FilterItems(searchInput.value)" type="text" placeholder="Benutzer suchen…"
             class="block w-full rounded-xl border border-gray-200 bg-white py-2.5 pl-10 pr-3 shadow-sm
                    focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 sm:text-sm
                    transition-all duration-200 placeholder-gray-300">
    </div>
    <div class="flex w-full lg:w-auto rounded-xl border border-gray-200 bg-white p-1 shadow-sm">
      <button type="button" (click)="setActiveFilter('all')"
              class="flex-1 lg:flex-none whitespace-nowrap px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200"
              [ngClass]="activeFilter === 'all' ? 'bg-theme-primary-50 text-theme-primary-600 shadow-sm' : 'text-gray-500 hover:bg-gray-100/80 hover:text-gray-900'">Alle</button>
      <button type="button" (click)="setActiveFilter('active')"
              class="flex-1 lg:flex-none whitespace-nowrap px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200"
              [ngClass]="activeFilter === 'active' ? 'bg-theme-primary-50 text-theme-primary-600 shadow-sm' : 'text-gray-500 hover:bg-gray-100/80 hover:text-gray-900'">Aktiv</button>
      <button type="button" (click)="setActiveFilter('inactive')"
              class="flex-1 lg:flex-none whitespace-nowrap px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200"
              [ngClass]="activeFilter === 'inactive' ? 'bg-theme-primary-50 text-theme-primary-600 shadow-sm' : 'text-gray-500 hover:bg-gray-100/80 hover:text-gray-900'">Inaktiv</button>
    </div>
    <select (change)="setSort($any($event.target).value)"
            class="w-full lg:w-auto rounded-xl border border-gray-200 bg-white py-2.5 pl-3 pr-8 text-sm text-gray-700 shadow-sm
                   focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 transition-all duration-200">
      <option value="name" [selected]="sortKey === 'name'">Name (A–Z)</option>
      <option value="newest" [selected]="sortKey === 'newest'">Neueste</option>
      <option value="modified" [selected]="sortKey === 'modified'">Zuletzt geändert</option>
    </select>
  </div>
  </div>

  <!-- Creator / context form -->
  @if (shard_filter != '' || company_filter != '' || creator) {
  <div class="border border-gray-100 rounded-2xl p-4 sm:p-6 bg-gray-50/50">
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      @if (creator) {
      <div class="sm:col-span-3">
        <label class="block text-sm font-bold text-gray-700 mb-2 tracking-tight" for="name">Benutzername</label>
        <input [(ngModel)]="name" id="name" name="name" type="text" placeholder="max.mustermann"
               class="block w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm
                      focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 sm:text-sm
                      transition-all duration-200 placeholder-gray-300">
      </div>

      <div class="sm:col-span-3">
        <label class="block text-sm font-bold text-gray-700 mb-2 tracking-tight" for="password">Passwort</label>
        <input [(ngModel)]="password" id="password" name="password" type="password" placeholder="••••••••"
               class="block w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm
                      focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 sm:text-sm
                      transition-all duration-200 placeholder-gray-300">
      </div>

      <div class="hidden sm:block sm:col-span-3"></div>

      <div class="sm:col-span-3">
        <label class="block text-sm font-bold text-gray-700 mb-2 tracking-tight" for="c-password">Passwort bestätigen</label>
        <input [(ngModel)]="cPassword" id="c-password" name="c-password" type="password" placeholder="••••••••"
               class="block w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm
                      focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 sm:text-sm
                      transition-all duration-200 placeholder-gray-300">
      </div>
      }

      <div [class.sm:col-span-full]="!creator && company_filter != '' && shard_filter == ''"
           [hidden]="!creator && company_filter == '' && shard_filter == ''"
           class="sm:col-span-3">
        <label class="block text-sm font-bold text-gray-700 mb-2 tracking-tight" for="company">Unternehmen</label>
        <select (change)="SetShard()" [(ngModel)]="company" [disabled]="!creator" id="company" name="company"
                class="block w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm
                       focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 sm:text-sm
                       transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500">
          @for (company of companies; track company.id) {
            <option [ngValue]="company">{{ company.name }}</option>
          }
        </select>
      </div>

      <div [hidden]="!creator && shard_filter == ''" class="sm:col-span-3">
        <label class="block text-sm font-bold text-gray-700 mb-2 tracking-tight" for="shard">Shard</label>
        <select [(ngModel)]="shard" [disabled]="!creator" id="shard" name="shard"
                class="block w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm
                       focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 sm:text-sm
                       transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500">
          @for (shard of (company != undefined ? company.shards : []); track shard.id) {
            <option [ngValue]="shard">{{ shard.name }}</option>
          }
        </select>
      </div>

      <!-- Role toggles -->
      <div [hidden]="!creator" class="col-span-full flex flex-wrap items-center gap-6 pt-2">
        <label class="flex items-center gap-3 cursor-pointer">
          <span class="relative inline-flex items-center">
            <input type="checkbox" class="peer sr-only" [checked]="owner"
                   (change)="owner = $any($event.target).checked">
            <span class="h-6 w-11 rounded-full bg-gray-300 after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5
                         after:rounded-full after:bg-white after:transition-all peer-checked:bg-theme-primary-600
                         peer-checked:after:translate-x-5"></span>
          </span>
          <span class="text-sm font-medium text-gray-900">Owner</span>
        </label>
        <label class="flex items-center gap-3 cursor-pointer">
          <span class="relative inline-flex items-center">
            <input type="checkbox" class="peer sr-only" [checked]="admin"
                   (change)="admin = $any($event.target).checked">
            <span class="h-6 w-11 rounded-full bg-gray-300 after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5
                         after:rounded-full after:bg-white after:transition-all peer-checked:bg-theme-primary-600
                         peer-checked:after:translate-x-5"></span>
          </span>
          <span class="text-sm font-medium text-gray-900">Admin</span>
        </label>
        <label class="flex items-center gap-3 cursor-pointer">
          <span class="relative inline-flex items-center">
            <input type="checkbox" class="peer sr-only" [checked]="protected"
                   (change)="protected = $any($event.target).checked">
            <span class="h-6 w-11 rounded-full bg-gray-300 after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5
                         after:rounded-full after:bg-white after:transition-all peer-checked:bg-theme-primary-600
                         peer-checked:after:translate-x-5"></span>
          </span>
          <span class="text-sm font-medium text-gray-900">Protected</span>
        </label>
      </div>

      @if (creator) {
      <div class="col-span-full flex justify-end pt-2">
        <button (click)="AddUser()" type="submit"
                class="inline-flex items-center justify-center px-5 py-2.5 bg-theme-primary-600 text-white rounded-2xl
                       hover:bg-theme-primary-700 font-semibold shadow-lg shadow-theme-primary-100 hover:shadow-xl
                       transition-all duration-200 active:scale-95">
          Benutzer anlegen
        </button>
      </div>
      }
    </div>
  </div>
  }

  @if (users != undefined) {
    <p class="text-sm text-gray-500">
      <span class="font-semibold text-gray-700">{{ filtered_users?.length || 0 }}</span>
      von {{ users.length }} Benutzern
    </p>
  }

  @if (users == undefined) {
    <app-loading></app-loading>
  }

  @if (users != undefined && filtered_users?.length === 0) {
    <p class="text-sm text-gray-500 italic py-6 border-2 border-dashed border-gray-100 rounded-2xl text-center">
      {{ searchText || activeFilter !== 'all' ? 'Keine Benutzer gefunden.' : 'Noch keine Benutzer angelegt.' }}
    </p>
  }

  @if (filtered_users && filtered_users.length > 0) {
    <!-- Desktop: data table. -->
    <div class="hidden md:block overflow-x-auto rounded-2xl border border-gray-100 bg-white shadow-sm">
      <table class="min-w-full divide-y divide-gray-100 text-sm">
        <thead class="bg-gray-50">
          <tr class="text-left text-xs uppercase tracking-wide text-gray-500">
            <th class="px-4 py-3 font-semibold">Benutzer</th>
            <th class="px-4 py-3 font-semibold">Unternehmen · Shard</th>
            <th class="px-4 py-3 font-semibold">Passwort-Auth</th>
            <th class="px-4 py-3 font-semibold">Status</th>
            <th class="px-4 py-3 text-right font-semibold">Aktionen</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          @for (user of filtered_users; track user.id) {
          <tr class="transition-colors hover:bg-gray-50">
            <td class="px-4 py-3">
              <div class="flex items-center gap-3">
                <img alt="" class="h-9 w-9 flex-shrink-0 rounded-full" src="./assets/images/icon_nobackground_md.png">
                <div class="min-w-0">
                  <span class="block truncate font-semibold text-gray-900">{{ user.name }}</span>
                  <span class="block truncate font-mono text-xs text-gray-500">{{ user.id }}</span>
                </div>
              </div>
            </td>
            <td class="px-4 py-3 text-gray-600">{{ user.company.name }} · {{ user.shard.name }}</td>
            <td class="px-4 py-3">
              <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                    [ngClass]="user.login ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'">{{ user.login ? 'Aktiviert' : 'Deaktiviert' }}</span>
            </td>
            <td class="px-4 py-3">
              <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                    [ngClass]="user.active ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'">{{ user.active ? 'Aktiv' : 'Inaktiv' }}</span>
            </td>
            <td class="px-4 py-3">
              <div class="flex items-center justify-end gap-1">
                <button (click)="ManageAuth(user)" type="button" title="Authentifizierung verwalten" aria-label="Authentifizierung verwalten"
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200 active:scale-95">
                  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
                  </svg>
                </button>
                <button (click)="Impersonate(user)" type="button" title="Impersonate user" aria-label="Impersonate user"
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-theme-primary-600 hover:bg-theme-primary-50 hover:text-theme-primary-700 transition-all duration-200 active:scale-95">
                  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </button>
                <button (click)="RemoveUser(user)" type="button" aria-label="Löschen"
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-red-50 hover:text-red-600 transition-all duration-200 active:scale-95">
                  <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd"
                          d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.583.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z"
                          clip-rule="evenodd"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Mobile: cards. -->
    <ul class="grid grid-cols-1 gap-4 md:hidden" role="list">
      @for (user of filtered_users; track user.id) {
      <li class="flex flex-col gap-3 border border-gray-100 rounded-2xl p-4 bg-white shadow-sm hover:shadow-md transition-all">
        <div class="flex items-center gap-3">
          <img alt="" class="h-12 w-12 flex-shrink-0 rounded-full" src="./assets/images/icon_nobackground_md.png">
          <div class="min-w-0 flex-1">
            <span class="block truncate text-sm font-bold text-gray-900">{{ user.name }}</span>
            <span class="block truncate text-xs font-medium text-gray-500">{{ user.company.name }} · {{ user.shard.name }}</span>
            <span class="block truncate font-mono text-xs text-gray-500">{{ user.id }}</span>
          </div>
          <div class="flex flex-shrink-0 items-center gap-1">
            <button (click)="ManageAuth(user)" type="button" title="Authentifizierung verwalten" aria-label="Authentifizierung verwalten"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-xl text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200 active:scale-95">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
              </svg>
            </button>
            <button (click)="Impersonate(user)" type="button" title="Impersonate user" aria-label="Impersonate user"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-xl text-theme-primary-600 hover:bg-theme-primary-50 hover:text-theme-primary-700 transition-all duration-200 active:scale-95">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </button>
            <button (click)="RemoveUser(user)" type="button" aria-label="Löschen"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-xl text-gray-400 hover:bg-red-50 hover:text-red-600 transition-all duration-200 active:scale-95">
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                      d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.583.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z"
                      clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="flex flex-wrap items-center gap-2 text-sm">
          <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                [ngClass]="user.active ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'">{{ user.active ? 'Aktiv' : 'Inaktiv' }}</span>
          <span class="text-gray-300">·</span>
          <span class="font-bold text-gray-700">Passwort-Auth</span>
          <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                [ngClass]="user.login ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'">{{ user.login ? 'Aktiviert' : 'Deaktiviert' }}</span>
        </div>
      </li>
      }
    </ul>
  }
</div>

<!-- Authenticator management modal (admin). Responsive: full-width sheet on phones, centered card on sm+. -->
@if (authUser) {
<div class="fixed inset-0 z-[1100] flex items-end sm:items-center justify-center bg-black/40 p-0 sm:p-4"
     (click)="CloseAuth()">
  <div class="w-full sm:max-w-lg bg-white rounded-t-2xl sm:rounded-2xl shadow-xl max-h-[90vh] overflow-y-auto"
       (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200">
      <h3 class="font-semibold text-gray-900">Authentifizierung — {{ authUser.name }}</h3>
      <button type="button" (click)="CloseAuth()" aria-label="Schließen" class="text-gray-500 hover:text-gray-700 text-xl leading-none">&times;</button>
    </div>

    @if (authData; as data) {
    <div class="p-5 space-y-5">
      <!-- authenticators -->
      <div>
        <p class="text-sm font-medium text-gray-700 mb-2">Externe Authentifizierung</p>
        @if (data.authenticators.length) {
          <ul class="divide-y divide-gray-200 rounded-md border border-gray-200">
            @for (a of data.authenticators; track a.id) {
              <li class="flex flex-col gap-2 p-3 sm:flex-row sm:items-center sm:justify-between">
                <span class="min-w-0">
                  <span class="block text-sm font-medium text-gray-900 truncate">{{ a.email || a.displayName || a.provider }}</span>
                  <span class="block text-xs text-gray-500">{{ a.provider }}</span>
                </span>
                <button type="button" (click)="RemoveAuth(a.id)"
                        class="self-start sm:self-auto rounded-md bg-red-50 px-3 py-1.5 text-sm font-medium text-red-600 hover:bg-red-100">
                  Entfernen
                </button>
              </li>
            }
          </ul>
        } @else {
          <p class="text-sm text-gray-500">Keine externe Authentifizierung verknüpft.</p>
        }

        <!-- link an existing identity -->
        <div class="mt-3 flex flex-col gap-2 sm:flex-row">
          <select [(ngModel)]="selectedIdentityId"
                  class="w-full rounded-md border-2 border-gray-200 px-2 py-1.5 text-sm text-gray-900">
            <option value="">Externe Identität wählen…</option>
            @for (id of allIdentities; track id.id) {
              <option [value]="id.id">{{ id.email || id.displayName || id.provider }} ({{ id.provider }})</option>
            }
          </select>
          <button type="button" (click)="LinkIdentity()" [disabled]="!selectedIdentityId"
                  class="rounded-md bg-theme-primary-700 px-3 py-1.5 text-sm font-semibold text-white hover:bg-theme-primary-900 disabled:opacity-50">
            Verknüpfen
          </button>
        </div>
      </div>

      <!-- password-login toggle -->
      <div class="flex items-center justify-between gap-4 rounded-md border border-gray-200 p-3">
        <span class="min-w-0">
          <span id="user-password-login-label" class="block text-sm font-medium text-gray-900">Passwort-Login</span>
          <span id="user-password-login-hint" class="block text-xs text-gray-500">Deaktivierung nur mit mind. einer externen Authentifizierung.</span>
        </span>
        <!-- Named explicitly: the words sit in the sibling span, so the control has no accessible name of its
             own. Same gap, same fix, as the two self-service profile screens. -->
        <label class="relative inline-flex cursor-pointer items-center">
          <input type="checkbox" class="peer sr-only" [checked]="data.passwordLoginEnabled"
                 aria-labelledby="user-password-login-label" aria-describedby="user-password-login-hint"
                 (change)="TogglePassword($any($event.target).checked)">
          <span class="h-6 w-11 rounded-full bg-gray-300 after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5 after:rounded-full after:bg-white after:transition-all peer-checked:bg-theme-primary-700 peer-checked:after:translate-x-5"></span>
        </label>
      </div>
    </div>
    }
  </div>
</div>
}

